import { User } from "./User";

export class UserActivity {
  constructor() {

  }

  public UserActivityID: string;
  public UserID: string;
  public Page: string;
  public Action: string;
  public ActionValue: string;
  public TimeStamp: Date;
  public User: User;
}
